var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "BasicNoteCard",
    {
      attrs: {
        firstName: _vm.firstName,
        lastName: _vm.lastName,
        jobTitle: _vm.jobTitle,
        location: _vm.location,
        note: _vm.note,
        avatar: _vm.avatar,
        openDate: _vm.openDate,
      },
      scopedSlots: _vm._u(
        [
          _vm.showEditTemplate
            ? {
                key: "actions",
                fn: function () {
                  return [
                    _c("div", { staticClass: "flex flex-wrap" }, [
                      _c(
                        "a",
                        { staticClass: "flex mr-2", attrs: { href: "#" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "mx-auto h-4 w-auto mt-1",
                              attrs: { alt: "delete notes" },
                              on: { click: _vm.removeNote },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "18",
                                    height: "18",
                                    viewBox: "0 0 18 18",
                                    fill: "none",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M6.23896 1.56015L6.239 1.56006C6.40509 1.22481 6.7465 1.01562 7.11875 1.01562H10.8813C11.2535 1.01562 11.5949 1.22481 11.761 1.56006L11.761 1.56015L11.986 2.00703L11.9904 2.01562H12H15C15.5445 2.01562 15.9844 2.4555 15.9844 3C15.9844 3.5445 15.5445 3.98438 15 3.98438H3C2.4555 3.98438 2.01562 3.5445 2.01562 3C2.01562 2.4555 2.4555 2.01562 3 2.01562H6H6.00963L6.01396 2.00703L6.23896 1.56015ZM3.01562 5.01562H14.9844V15C14.9844 16.0945 14.0945 16.9844 13 16.9844H5C3.9055 16.9844 3.01562 16.0945 3.01562 15V5.01562ZM6 6.98438C5.71637 6.98438 5.48438 7.21637 5.48438 7.5V14.5C5.48438 14.7836 5.71637 15.0156 6 15.0156C6.28363 15.0156 6.51562 14.7836 6.51562 14.5V7.5C6.51562 7.21637 6.28363 6.98438 6 6.98438ZM9 6.98438C8.71637 6.98438 8.48438 7.21637 8.48438 7.5V14.5C8.48438 14.7836 8.71637 15.0156 9 15.0156C9.28363 15.0156 9.51562 14.7836 9.51562 14.5V7.5C9.51562 7.21637 9.28363 6.98438 9 6.98438ZM12 6.98438C11.7164 6.98438 11.4844 7.21637 11.4844 7.5V14.5C11.4844 14.7836 11.7164 15.0156 12 15.0156C12.2836 15.0156 12.5156 14.7836 12.5156 14.5V7.5C12.5156 7.21637 12.2836 6.98438 12 6.98438Z",
                                      fill: "#010A11",
                                      stroke: "#010A11",
                                      "stroke-width": "0.03125",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("a", { staticClass: "flex", attrs: { href: "#" } }, [
                        _c(
                          "div",
                          {
                            staticClass: "mx-auto h-4 w-auto mr-1 mt-1",
                            on: { click: _vm.editNote },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  width: "18",
                                  height: "18",
                                  viewBox: "0 0 18 18",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M16.7375 2.51328C16.0531 1.82891 14.9469 1.82891 14.2625 2.51328L13.3219 3.45078L16.3813 6.51016L17.3219 5.56953C18.0063 4.88516 18.0063 3.77891 17.3219 3.09453L16.7375 2.51328ZM7.3875 9.38828C7.19687 9.57891 7.05 9.81328 6.96562 10.0727L6.04063 12.8477C5.95 13.1164 6.02188 13.4133 6.22188 13.6164C6.42188 13.8195 6.71875 13.8883 6.99062 13.7977L9.76562 12.8727C10.0219 12.7883 10.2562 12.6414 10.45 12.4508L15.6781 7.21953L12.6156 4.15703L7.3875 9.38828ZM5 3.83516C3.34375 3.83516 2 5.17891 2 6.83516V14.8352C2 16.4914 3.34375 17.8352 5 17.8352H13C14.6562 17.8352 16 16.4914 16 14.8352V11.8352C16 11.282 15.5531 10.8352 15 10.8352C14.4469 10.8352 14 11.282 14 11.8352V14.8352C14 15.3883 13.5531 15.8352 13 15.8352H5C4.44688 15.8352 4 15.3883 4 14.8352V6.83516C4 6.28203 4.44688 5.83516 5 5.83516H8C8.55312 5.83516 9 5.38828 9 4.83516C9 4.28203 8.55312 3.83516 8 3.83516H5Z",
                                    fill: "#717986",
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]
                },
                proxy: true,
              }
            : null,
        ],
        null,
        true
      ),
    },
    [
      _vm.editModal
        ? _c("EditNotesModal", {
            attrs: {
              currentUserId: _vm.currentUserId,
              contractorId: _vm.contractorId,
              id: _vm.id,
              note: _vm.note,
              title: "Edit Notes",
            },
            on: { close: _vm.closeEdit, edit: _vm.editNotesToContractors },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }